import api from '@pray/shared/utils/api';

export type SuperFunnelMigrationAutomationStatus = 'draft' | 'active' | 'stopped';

type SuperFunnelMigrationAutomationData = {
  workflow_id: string;
  artist_id: string;
  artist_name: string;
  workflow_name: string;
  status: SuperFunnelMigrationAutomationStatus;
  published_version: number | null;
  published_version_count: number;
  trigger_type: string | null;
  trigger_campaign_id: number | null;
  trigger_count: number;
  email_campaign_count: number;
  entry_count: number;
  last_entry_at: string | null;
  last_updated_at: string;
};

export type SuperFunnelMigrationAutomation = {
  workflowId: string;
  artistId: string;
  artistName: string;
  workflowName: string;
  status: SuperFunnelMigrationAutomationStatus;
  publishedVersion: number | null;
  publishedVersionCount: number;
  triggerType: string | null;
  triggerCampaignId: number | null;
  triggerCount: number;
  emailCampaignCount: number;
  entryCount: number;
  lastEntryAt: string | null;
  lastUpdatedAt: string;
};

type SuperFunnelMigrationAutomationsResponse = {
  automations: SuperFunnelMigrationAutomationData[];
};

function mapAutomation(data: SuperFunnelMigrationAutomationData): SuperFunnelMigrationAutomation {
  return {
    workflowId: data.workflow_id,
    artistId: data.artist_id,
    artistName: data.artist_name,
    workflowName: data.workflow_name,
    status: data.status,
    publishedVersion: data.published_version,
    publishedVersionCount: data.published_version_count,
    triggerType: data.trigger_type,
    triggerCampaignId: data.trigger_campaign_id,
    triggerCount: data.trigger_count,
    emailCampaignCount: data.email_campaign_count,
    entryCount: data.entry_count,
    lastEntryAt: data.last_entry_at,
    lastUpdatedAt: data.last_updated_at,
  };
}

export async function getSuperFunnelMigrationAutomations(): Promise<SuperFunnelMigrationAutomation[]> {
  const response = await api.executeGetRequest<{ data: SuperFunnelMigrationAutomationsResponse }>(
    '/web/studio/admin/superfunnel-automations'
  );

  return response.data.data.automations.map(mapAutomation);
}
